import React from 'react';
import { Heart, RefreshCw } from 'lucide-react';

export const DonorWallSection = ({ donorWall }) => {
  if (!donorWall || donorWall.length === 0) return null;

  return (
    <section className="py-12 bg-white" data-testid="donor-wall-section">
      <div className="px-6">
        <div className="text-center mb-8">
          <p className="text-sm uppercase tracking-[0.15em] text-[#BA1826] font-semibold mb-2">
            Thank You
          </p>
          <h2 className="font-heading text-2xl font-bold text-[#0A0A0A]">
            Our Generous Supporters
          </h2>
          <p className="text-sm text-[#4B5563] mt-2">
            We're grateful to everyone who supports our mission
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {donorWall.slice(0, 12).map((donor) => (
              <div
                key={donor.id}
                className="bg-[#F8F9FA] p-4 border border-[#E5E7EB] text-center rounded-sm"
              >
                <Heart className="w-5 h-5 text-[#BA1826] mx-auto mb-2" />
                <p className="font-medium text-sm text-[#0A0A0A]">{donor.name}</p>
                {donor.amount && <p className="text-xs text-[#4B5563]">${donor.amount}</p>}
                {donor.is_recurring && (
                  <span className="inline-flex items-center gap-1 text-xs text-[#BA1826] mt-1">
                    <RefreshCw className="w-3 h-3" /> Recurring
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
